/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  GameMission,
  GameMissions,
  GameMissionsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Missions list
 */
export const gameMissions = (
    params?: MaybeRefOrGetter<GameMissionsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<GameMissions>(
      {url: `/missions`, method: 'GET',
        params, signal
    },
      );
    }




export const getGameMissionsQueryKey = (params?: MaybeRefOrGetter<GameMissionsParams>,) => {
    return [
    'missions', ...(params ? [params] : [])
    ] as const;
    }


export const getGameMissionsQueryOptions = <TData = Awaited<ReturnType<typeof gameMissions>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<GameMissionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameMissions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGameMissionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gameMissions>>> = ({ signal }) => gameMissions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gameMissions>>, TError, TData>
}

export type GameMissionsQueryResult = NonNullable<Awaited<ReturnType<typeof gameMissions>>>
export type GameMissionsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Missions list
 */

export function useGameMissions<TData = Awaited<ReturnType<typeof gameMissions>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<GameMissionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameMissions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGameMissionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Mission detail
 */
export const gameMission = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<GameMission>(
      {url: `/missions/${slug}`, method: 'GET', signal
    },
      );
    }




export const getGameMissionQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'missions',slug
    ] as const;
    }


export const getGameMissionQueryOptions = <TData = Awaited<ReturnType<typeof gameMission>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameMission>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGameMissionQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gameMission>>> = ({ signal }) => gameMission(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gameMission>>, TError, TData>
}

export type GameMissionQueryResult = NonNullable<Awaited<ReturnType<typeof gameMission>>>
export type GameMissionQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Mission detail
 */

export function useGameMission<TData = Awaited<ReturnType<typeof gameMission>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameMission>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGameMissionQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






